import { Group, UnstyledButton } from '@mantine/core';

import { IconSelect } from 'src/Components/Shared/IconSelect';

import styles from './IconColorPicker.module.scss';
import { Props } from './IconColorPicker.types';

const IconColorPicker = ({ icons, colors, icon, color, onIconChange, onColorChange }: Props) => {
  return (
    <div className={styles.container}>
      <IconSelect
        icons={icons}
        value={icon}
        allowDeselect={false}
        onChange={value => value && onIconChange(value)}
      />
      <Group gap={8} className={styles.colorGroup}>
        {colors.map(option => (
          <UnstyledButton
            key={option.key}
            className={styles.colorButton}
            style={{ backgroundColor: option.hex }}
            onClick={() => onColorChange(option.key)}
            data-selected={color === option.key}
            aria-label={option.key}
          />
        ))}
      </Group>
    </div>
  );
};

export default IconColorPicker;
